import { render, staticRenderFns } from "./cardTemplateVip27.vue?vue&type=template&id=60238a70&scoped=true&"
import script from "./cardTemplateVip27.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip27.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip27.vue?vue&type=style&index=0&id=60238a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60238a70",
  null
  
)

export default component.exports